import { Component, input, output, signal } from '@angular/core';
import { ApiHostLocation } from '@core/services/hosts/hosts.interfaces';
import { Button, Tabs } from '@ntv360/component-pantry';
import { SVG_ICONS } from '@shared/constants';
import { DetailsComponent, HoursComponent } from './tabs';

@Component({
    selector: 'app-edit-screen',
    imports: [Tabs, Button, DetailsComponent, HoursComponent],
    templateUrl: './edit-screen.component.html',
    styleUrl: './edit-screen.component.scss',
})
export class EditScreenComponent {
    public readonly hostData = input<ApiHostLocation | null>(null);

    public readonly deleteClick = output<void>();
    public readonly cancelClick = output<void>();
    public readonly updateClick = output<void>();

    public icons = SVG_ICONS;
    public spritePath = 'assets/icons/icons-sprite.svg';

    /**
     * Tabs configuration for the edit screen modal
     */
    public tabs = [{ label: 'Details' }, { label: 'Hours' }];

    /**
     * Active tab index
     */
    public activeTab = signal(0);

    /**
     * Handles tab change events
     * @param index - The index of the selected tab
     */
    public onTabChange(index: number): void {
        this.activeTab.set(index);
    }
}
